const apiURL = isProduction()
  ? "https://api.jayvisa.com?route="
  : "http://localhost:8080?route=";

export { apiURL };

function isProduction() {
  if (window.location.href.indexOf("localhost") === -1) return true;
}
